export const PERMISSION = {
  VIEW: "view",
  CREATE: "create",
  EDIT: "edit",
  DELETE: "delete",
  EXPORT: "export",
};

export const PERMISSION_LABELS = [
  { key: PERMISSION.VIEW, label: "View" },
  { key: PERMISSION.CREATE, label: "Create" },
  { key: PERMISSION.EDIT, label: "Edit" },
  { key: PERMISSION.DELETE, label: "Delete" },
  { key: PERMISSION.EXPORT, label: "Export" },
];

export const MENU = {
  DASHBOARD: 1,
  USER: 2,
  OFFERS: 3,
  HOME: 4,
  CATALOGUE: 5,
  ORDER: 6,
  SETTINGS: 7,
  DRIVER: 8,
  WALLET: 9,
  BULK_EDIT: 10,
  PRODUCT_COSTS: 11,
  PRODUCT_REGULAR_PRICE: 12,
  PRODUCT_SALE_PRICE: 13,
};

// Per-menu permission applicability. Defaults to all five actions; only listed
// menus restrict which permission columns are meaningful in the matrix UI.
// `Product Costs` is a field-level scope (not a CRUD module), so create/delete
// don't apply — only view / edit / export do. The price scopes are similar
// but back-end only honours view / edit (no export contract).
export const MENU_APPLICABLE_PERMISSIONS = {
  [MENU.PRODUCT_COSTS]: [PERMISSION.VIEW, PERMISSION.EDIT, PERMISSION.EXPORT],
  [MENU.PRODUCT_REGULAR_PRICE]: [PERMISSION.VIEW, PERMISSION.EDIT],
  [MENU.PRODUCT_SALE_PRICE]: [PERMISSION.VIEW, PERMISSION.EDIT],
};

export const getApplicablePermissions = (menuId) =>
  MENU_APPLICABLE_PERMISSIONS[Number(menuId)] || Object.values(PERMISSION);

export const isPermissionLabel = (value) =>
  Object.values(PERMISSION).includes(value);

export const normalizePermissionLevels = (raw) => {
  if (Array.isArray(raw)) return raw.filter(isPermissionLabel);
  if (typeof raw === "string") {
    return raw
      .replace(/"/g, "")
      .split(",")
      .map((v) => v.trim())
      .filter(isPermissionLabel);
  }
  return [];
};
